/*
  Stops the promo notification banner coming back once someone has dealt with
  it. The theme's own limit-display setting counts how many times the banner
  has been SHOWN, which also hides it from someone who never noticed it. This
  counts interaction instead: close it or click it, and it is gone.

  popup.js bails out of openPopup when the element already carries
  popup-already-opened, so setting that class is enough to keep it shut.
*/
(function () {
  var KEY = 'orb-notification-banner-dismissed';
  var BANNER = '.notification-banner.popup';

  function isDismissed() {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      // Private browsing, or storage blocked. Behave as it did before.
      return false;
    }
  }

  function remember() {
    try {
      localStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  function apply() {
    if (window.Shopify && Shopify.designMode) return;
    if (!isDismissed()) return;
    document.querySelectorAll(BANNER).forEach(function (el) {
      el.classList.add('popup-already-opened');
      el.classList.remove('popup-open');
    });
  }

  // Capture phase, so this still records the dismissal when the theme's own
  // handler closes the banner and removes the element's open state.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(BANNER)) remember();
    },
    true
  );

  apply();
  document.addEventListener('shopify:section:load', apply);
})();
